import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  Box,
  Grid,
  Avatar
} from '@mui/material';
import { KPIIndicator } from '../types';
import KPICard from './KPICard';

interface KPICategoryProps {
  title: string;
  subtitle: string;
  icon: string;
  color: string;
  kpis: KPIIndicator[];
  onKPIClick: (kpi: KPIIndicator) => void;
}

const KPICategory: React.FC<KPICategoryProps> = ({
  title,
  subtitle,
  icon,
  color,
  kpis,
  onKPIClick
}) => {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3, pb: 2, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Avatar
            sx={{
              width: 60,
              height: 60,
              mr: 2,
              background: color,
              fontSize: '1.8rem',
            }}
          >
            {icon}
          </Avatar>
          <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 600, mb: 0.5 }}>
              {title}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={2}>
          {kpis.map((kpi) => (
            <Grid item xs={12} key={kpi.id}>
              <KPICard kpi={kpi} onClick={onKPIClick} />
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default KPICategory; 